import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
//import { ErrorResult } from '../models/interface';
import { IMessageServiceData } from '../models/messageservice';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private subject = new Subject<any>();

  sendMessage(message: IMessageServiceData | null) {
    this.subject.next({ text: message });
  }


  clearMessages() {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
